<template>
	<div :class="{ hidden: ishidden }" class="whole-modal">
		<!-- form itself end-->
		<form id="test-form" data-aos="zoom-in" class="white-popup-block">
			<div class="popup_box">
				<span @click="toggleActive" class="exit-icon"></span>

				<div class="popup_inner">
					<h3>{{ $t("nav.appointment") }}</h3>
					<form action="#" id="appForm" @submit.prevent="submit">
						<div class="row">
							<div v-show="messageForm" class="col-12">
								<p class="submitMsg" :class="{ success: isSubmited, faild: !isSubmited }">
									{{ submitMsg }}
								</p>
							</div>
							<div class="col-xl-6 col-md-6">
								<VueCtkDateTimePicker
									:minute-interval="10"
									color="#422e25"
									enable-button-validate
									only-date="true"
									format="YYYY-MM-DD"
									formatted="ddd D MMM YYYY"
									v-model="formdata.date"
									max-date
									onlyDate
									:min-date="currenttime"
								>
									<input autocomplete="off" id="datepicker" :placeholder="$t('modal.date') " />
								</VueCtkDateTimePicker>
							</div>
							<div class="col-xl-6 col-md-6">
								<VueCtkDateTimePicker
									minute-interval="15"
									color="#422e25"
									enable-button-validate
									onlyTime
									formatted="h:mm a"
									format="HH:mm"
									time-format="h:mm a"
									v-model="formdata.time"
									min-time="9:00"
								>
									<input autocomplete="off" id="timepicker" :placeholder=" $t('modal.time') " />
								</VueCtkDateTimePicker>
							</div>
							<div class="col-xl-6 col-md-6">
								<multiselect
									:placeholder="$t('modal.service') "
									:value="value"
									:options="$t('serviceOptions.options')"
									:searchable="false"
									v-model="formdata.service"
									:multiple="true"
									:limit="2"
									:show-labels="false"
								></multiselect>
							</div>
							<div class="col-xl-6 col-md-6">
								<multiselect
									:placeholder="$t('modal.barber') "
									:value="barber"
									:options="barbers"
									:searchable="false"
									v-model="formdata.person"
									:show-labels="false"
								></multiselect>
							</div>
							<div class="col-xl-6 col-md-6">
								<input type="text" :placeholder="$t('modal.name') " v-model="formdata.name" />
							</div>
							<div class="col-xl-6 col-md-6">
								<input :placeholder="$t('modal.phone') " type="tel" v-model="formdata.phone" />
							</div>
							<div class="col-xl-12">
								<input type="email" :placeholder="$t('modal.email') " v-model="formdata.email" />
							</div>
							<div class="col-xl-12">
								<button type="submit" class="boxed-btn3">{{$t('modal.submit')}}</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</form>
		<!-- form itself end -->
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { db } from '../../store/firebase';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Multiselect from 'vue-multiselect';

const documnetPath = 'clientapp/forms';
export default {
	data() {
		return {
			yourValue: '',
			value2: '',
			name: null,
			phone: null,
			date: null,
			time: null,
			person: null,
			service: null,
			email: null,
			submitMsg: '',
			messageForm: false,
			isSubmited: false,
			firebaseData: null,
			formdata: {},
			value: null,
			options: ['Heir cut', 'Men’s Facial', 'Face Massage', 'Beard and moustache'],
			barbers: ['Ayoub', 'Abdollah'],
			barber: null,
		};
	},
	created() {
		setInterval(this.getNow, 1000);
		const today = new Date();
		const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + (today.getDate() + 1);

		this.currenttime = date;
	},
	firestore() {
		return {
			firebaseData: db.doc(documnetPath),
		};
	},

	components: { VueCtkDateTimePicker, Multiselect },

	computed: {
		...mapState(['ishidden']),
	},
	methods: {
		toggleActive() {
			this.$store.commit('toggleActive');
			console.log(this.firebaseData);
		},

		// form validation
		async submit() {
			if (this.formdata.service == null) {
				this.submitMsg = this.$t('messege.inputService');
			} else if (this.formdata.email == null) {
				this.submitMsg = this.$t('messege.inputEmail');
			} else if (this.formdata.date == null) {
				this.submitMsg =this.$t('messege.inputDate');
			} else if (this.formdata.time == null) {
				this.submitMsg =this.$t('messege.inputTime');
			} else if (this.formdata.phone == null) {
				this.submitMsg = this.$t('messege.inputPhone');
			} else {
				try {
					await db.collection('clientapp').add(this.formdata);
					this.submitMsg = "Thank you, we'll call you ASAP";
					this.isSubmited = true;
					this.formdata.name = null;
					this.formdata.email = null;
					this.formdata.person = null;
					this.formdata.phone = null;
					this.formdata.service = null;
					this.formdata.date = null;
					this.formdata.time = null;
					// return the promise so we can await the write
					this.state = 'synced';
				} catch (error) {
					this.submitMsg = JSON.stringify(error);
					this.state = 'error';
				}
			}
			this.messageForm = true;
		},
	},
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
@import '/../styles/css/magnific-popup.css';
@import '/../styles/css/nice-select.css.css';
@import '../../styles/_responsive.scss';
@import '../../styles/_mixins.scss';
@import '../../styles/_varriable.scss';
@import '../../styles/_reset.scss';
@import '../../styles/_btn.scss';
@import '../../styles/_section_title.scss';
@import '../../styles/font/flaticon.css';
@import '../../styles/font/font-awesome.min.css';
@import '../../styles/pages/_gallery.scss';
@import '../../styles/_elements.scss';
@import '../../styles/_bradcam.scss';
@import '../../styles/pages/_gallery.scss';
.hidden {
	display: none !important;
}
.success {
	color: #15b196;
	font-weight: 700;
	text-align: left;
	padding: 5px;
	border-radius: 5px;
	padding-left: 50px;
	background: #121519;
	position: relative;
	animation: MsgAnimation;
	-webkit-animation-duration: 1s;
	-webkit-animation-timing-function: ease-in-out;
	@-webkit-keyframes MsgAnimation {
		from {
			transform: translateY(10px);
			opacity: 0;
		}

		to {
			transform: translateY(0);
			opacity: 1;
		}
	}

	&:before {
		content: '';
		background: url('~@/assets../../img/icons/success.png');
		background-repeat: no-repeat;
		background-size: contain;
		position: absolute;
		top: 6px;
		left: 17px;
		width: 36px;
		height: 23px;
	}
}
.faild {
	background: #121519;
	color: #ffff;
	font-weight: 500;
	text-align: left;
	padding: 5px;
	border-radius: 5px;
	padding-left: 50px;
	position: relative;
	animation: MsgAnimation;
	-webkit-animation-duration: 1s;
	-webkit-animation-timing-function: ease-in-out;
	@-webkit-keyframes MsgAnimation {
		from {
			transform: translateY(10px);
			opacity: 0;
		}

		to {
			transform: translateY(0);
			opacity: 1;
		}
	}
	&:before {
		content: '';
		background: url('~@/assets../../img/icons/faild.png');
		background-repeat: no-repeat;
		background-size: contain;
		position: absolute;
		top: 6px;
		left: 17px;
		width: 36px;
		height: 23px;
	}
}
</style>
<style lang="scss">
@import '../../styles/_varriable.scss';
@import "../../styles/_responsive.scss";


.multiselect {
	margin-bottom: 30px;
		@media #{$mobile_device} 
		{
    margin-bottom: 15px;
   }
	.multiselect__tags {
		background-color: transparent;
		width: 100%;
		border-color: #7c869045;
	}
	.multiselect__tag .multiselect__input,
	.multiselect__single {
		background-color: transparent;
		color: #fff;
	}
	.multiselect__strong {
		color: #ffff;
	}
	.multiselect__option--highlight {
		background: #454e54;
	}
	.multiselect__option--selected {
		background: #432e24d6;
		color: #ffffff;
	}
	.multiselect__tag {
		background: $primary-color;
		i {
			&:after {
				color: #fff;
			}
		}
	}
	.multiselect__content {
		padding: 3px 0;
	}
}
</style>
